module.exports = __webpack_public_path__ + "86559eaaf6a197f04ebac54f4dbb67ea.svg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/sponsors/aranja.svg
 ** module id = 374
 ** module chunks = 0
 **/